import React, { useState } from "react";
import { useField } from "formik";
import Select from "react-select";

const Dropdown = ({
  label = "",
  options = [],
  required = false,
  needSearch = false,
  disabled = false,
  placeholder = "Select an option",
  className,
  name,
  onChange,
  ...props
}) => {
  // Check if inside Formik context
  let field, meta, helpers;
  let inFormik = true;
  try {
    [field, meta, helpers] = useField(props);
  } catch {
    inFormik = false;
  }

  // Standalone state (if not using Formik)
  const [localValue, setLocalValue] = useState("");

  const handleChange = (selectedOption) => {
    const selectedValue = selectedOption ? selectedOption.value : "";

    // If onChange is provided, use it
    if (onChange) {
      onChange(selectedValue, selectedOption);
    }

    // Update Formik state or local state
    if (inFormik) {
      helpers.setValue(selectedValue);
    } else {
      setLocalValue(selectedValue);
    }
  };

  const currentValue = () => {
    if (inFormik) {
      return options.find((option) => option.value === field.value) || null;
    }
    return options.find((option) => option.value === localValue) || null;
  };

  return (
    <div className="form-control flex flex-col gap-2 p-2 z-10 text-xs">
      {/* Label */}
      {label && (
        <label
          htmlFor={name}
          className="font-medium flex items-center"
        >
          {label}
          {required && <span className="text-red-600 font-bold ml-1">*</span>}
        </label>
      )}

      {/* Dropdown */}
      {needSearch ? (
        <Select
          options={options}
          isDisabled={disabled}
          onChange={handleChange}
          value={currentValue()}
          className={className}
          classNamePrefix="react-select"
          classNames="text-xs"
          placeholder={placeholder}
          isClearable
          noOptionsMessage={() => "No options available"}
        />
      ) : (
        <select
          {...(inFormik
            ? field
            : {
              value: localValue,
              onChange: (e) => {
                const selectedValue = e.target.value;
                const selectedOption = options.find(
                  (option) => option.value === selectedValue
                );
                handleChange(selectedOption);
              },
            })}
          {...props}
          className={`mt-1 block w-full px-3 py-2 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-xs ${inFormik && meta.touched && meta.error ? "border-red-500" : ""
            }`}
          disabled={disabled}
        >
          <option value="">{placeholder}</option>
          {options.length === 0 ? (
            <option value="">No options available</option>
          ) : (
            options.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))
          )}
        </select>
      )}

      {/* Error Message */}
      {inFormik && meta.touched && meta.error && (
        <p
          className="mt-2 text-xs text-red-500"
          id={`${name}-error`}
        >
          {meta.error}
        </p>
      )}
    </div>
  );
};

export default Dropdown;
